import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    :root {
      font-size: 16px;
      --toastify-toast-min-height: 48px
    }


    html {
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    html, body {
      height: 100%;
      font-variant-ligatures: no-contextual;
      font-family: ${({ theme }) => theme.fonts.inter};
      background-color: ${({ theme }) => theme.colors.surfacePrimary};

      svg {
        height: auto;
        max-width: 100%;
      }
    }

    .Toastify__toast-container {
      z-index: 99999999;
      width: var(--toastify-toast-width);
    }

    .Toastify__toast-container--top-left {
      top: 16px;
      left: 16px;
    }

    .Toastify__toast-body {
      padding: 0;
      margin: 0;
    }

    .Toastify__toast {
      margin-bottom: 1rem;
    }

    .no-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .default-network-icon-path {
      & > path {
        fill: #FFFFFF;
      }
    }
    .default-network-icon-circle {
      & > circle {
        fill: #2C3034;
      }
    }
`;

export default GlobalStyle;
